






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Alerta} from '@/model/resource/Alerta'
import {InputAlertaSchema} from '@/schema/resource/Alerta/InputAlertaSchema'

@Component
export default class PersistAlertaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAlertaSchema()
  alerta = new Alerta()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.alerta.getAlerta(id)
    }

    $.await.done('getAlerta')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('view.persistAlerta.error.descricaoEmpty')
    }

    await this.alerta.persistAlerta()
    await Helper.successAndPush('system.success.persist', '/alerta/list')
  }
}
